<template>
  <div class="LWB_wrapper">
    <div class="box">
      <div class="head">
        <div class="title">진행률:{{lession.progress}}%</div>
        <div class="menu">
          <svg
            class="_ufjrdd"
            viewBox="0 0 24 24"
            role="img"
            aria-labelledby="드롭다운메뉴e79d75e6-86c8-48b6-81bd-89e341ccfefd 드롭다운메뉴e79d75e6-86c8-48b6-81bd-89e341ccfefdDesc"
            xmlns="http://www.w3.org/2000/svg"
            style="fill: rgb(164, 164, 164); height: 28px; width: 28px;"
          >
            <title id="드롭다운메뉴e79d75e6-86c8-48b6-81bd-89e341ccfefd">드롭다운 메뉴</title>
            <path
              d="M12 8c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zm0 2c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0 6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z"
              role="presentation"
            />
          </svg>
        </div>
      </div>
      <div class="body">
        <div class="bend">{{lession.noti}}</div>
        <div class="_body">
          <div class="title">{{lession.title}}</div>
          <div class="action">
            <b-button variant="info" @click="goStudy()">강의듣기</b-button>
          </div>
        </div>
        <SimpleChart :ratio="ratios" class="chartbox" />
        <div class="footer">
          <div class="title">선명훈 선생님</div>
          <div class="title">k-12</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import SimpleChart from "@/components/SimpleChart.js";
export default {
  props: ["lession"],
  components: {
    SimpleChart,
  },
  computed: {
    ratios() {
      return [this.lession.ratio1, this.lession.ratio2, this.lession.ratio3];
    },
  },
  methods: {
    goStudy() {
      this.$router.push("/studyroom");
    },
  },
};
</script>


<style lang="scss" scoped>
@import "@/styles/_variables.scss";

.chartbox {
  height: 100px;
  width: 500px;
  margin-left: 50px;
  // display: none;
  // position: relative;
}

.LWB_wrapper {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  width: 1200px;
  margin-bottom: 25px;
}
.box {
  height: 380px;
  position: relative;
  width: 80%;
  transition: all 450ms cubic-bezier(0.23, 1, 0.32, 1) 0ms;
  border-radius: 3px;
  background-color: white;
  overflow: hidden;
  box-shadow: rgba(31, 31, 31, 0.12) 0px 1px 6px,
    rgba(31, 31, 31, 0.12) 0px 1px 4px;

  .head {
    height: 45px;
    // border-bottom: 1px solid $gray100;
    font-weight: 700;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 15px 0 15px;
  }

  .body {
    height: calc(100% - 45px);
    display: flex;
    flex-direction: column;
    // flex-grow: 45px 1;
    // align-content: stretch;
    align-items: stretch;

    .bend {
      flex-grow: 0;

      flex-basis: 45px;
      background-color: $gray100;
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 0 15px 0 15px;
      font-size: 0.8em;
      color: $point1;
    }
    ._body {
      flex-grow: 1;
      display: flex;
      justify-content: space-around;
      align-items: center;
      .title {
        font-size: 1.5em;
        color: $point1;
      }
    }
    .footer {
      flex-basis: 45px;
      border-top: 1px solid $gray100;
      margin: 0 20px 0 20px;

      display: flex;
      align-items: center;
      justify-content: space-between;
    }
  }
}
</style>